import Layout from './components/Layout';
import ResponsiveShadow from './components/ResponsiveShadow';

const Pncp = () => {
  return (
    <Layout>
      <ResponsiveShadow className="container mt-4 mb-4">
      </ResponsiveShadow>
    </Layout>
  );
}

export default Pncp;
